// Badge vertaling: NL -> DE op basis van URL pad
(function() {
  var translations = {
    'de': {
      'Veelgekochte bestseller': 'Meistgekaufter Bestseller',
      'veelgekochte bestseller': 'Meistgekaufter Bestseller',
      'Nieuw binnen': 'Neu eingetroffen',
      'nieuw binnen': 'Neu eingetroffen',
      'Beperkte voorraad': 'Begrenzter Vorrat',
      'beperkte voorraad': 'Begrenzter Vorrat',
      'Uitverkoop': 'Ausverkauf',
      'uitverkoop': 'Ausverkauf'
    }
  };

  function getLocale() {
    var path = window.location.pathname;
    if (path.startsWith('/de')) return 'de';
    return 'nl';
  }

  function translateBadges() {
    var locale = getLocale();
    if (locale === 'nl') return;

    var dict = translations[locale];
    if (!dict) return;

    // Zoek alle badge-elementen van SamitaLabels en andere badge-elementen
    var selectors = [
      '[class*="samita"]',
      '[class*="badge"]',
      '[class*="label"]',
      '[class*="sticker"]',
      '[data-badge]'
    ];

    selectors.forEach(function(selector) {
      try {
        var elements = document.querySelectorAll(selector);
        elements.forEach(function(el) {
          var original = el.innerText ? el.innerText.trim() : '';
          if (dict[original]) {
            el.innerText = dict[original];
          }
        });
      } catch(e) {}
    });
  }

  // Uitvoeren na laden van de pagina
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', translateBadges);
  } else {
    translateBadges();
  }

  // Ook uitvoeren na dynamisch laden (bijv. AJAX producten)
  var observer = new MutationObserver(function(mutations) {
    translateBadges();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

// GA4: klik op afrekenknop per type winkelwagen (mini_cart / full_cart)
(function () {
  window.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('#CartDrawer-Checkout, #checkout') : null;
    if (!t || t.disabled || typeof window.gtag !== 'function') return;
    window.gtag('event', 'checkout_click', { cart_type: t.id === 'checkout' ? 'full_cart' : 'mini_cart' });
  }, true);
})();